import './main.css';

async function main() {
  const mapElem = document.getElementById('map');
  if (mapElem) {
    const {createMap} = await import('./js/map');
    createMap(mapElem);
  }

  const pictureMapElem =
    document.querySelector<HTMLElement>('[data-picture-map]');
  if (pictureMapElem) {
    const {createPictureMap} = await import('./js/picture-map');
    createPictureMap(pictureMapElem);
  }
}

// because we're using dynamic imports we have
// to check if document dom is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
